module.exports = __webpack_public_path__ + "img/sub9.a74e03ce.jpg";